<script lang="ts">
  import { t } from '../lib/i18n.js';
  let { onBack } = $props<{ onBack: () => void }>();
</script>

<div class="card">
  <button onclick={onBack}>{$t('about.back')}</button>
  <h2>{$t('about.title')}</h2>

  <h3>{$t('about.section_browser_title')}</h3>
  {@html $t('about.section_browser_body')}

  <h3>{$t('about.section_policies_title')}</h3>
  {@html $t('about.section_policies_body')}

  <h3>{$t('about.section_server_title')}</h3>
  {@html $t('about.section_server_body')}

  <h3>{$t('about.section_blob_title')}</h3>
  {@html $t('about.section_blob_body')}

  <h3>{$t('about.section_integrity_title')}</h3>
  {@html $t('about.section_integrity_body')}

  <h3>{$t('about.section_keyfile_title')}</h3>
  {@html $t('about.section_keyfile_body')}
</div>
